import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import DynamicFormApi from '../generated/api/DynamicForm';

export default (service: Servicelayer) => ({
  ...DynamicFormApi(service),

  // Add custom calls here

});
